import { httpRequest } from "@/lib";
import {
  ProcedureConsumableInput,
  RequestProcedureResponse,
} from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type UpdateProcedureRequestDTO = {
  id: string;
  name: string;
  value: string;
  stock_items: ProcedureConsumableInput[];
  // time: string;
  // exam: string;
  // covenant: string;
};

async function updateProcedure(
  request: UpdateProcedureRequestDTO
): Promise<RequestProcedureResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put<RequestProcedureResponse>(
    `/procedures/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateProcedureMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateProcedure,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["procedures"] });
    },
  });
}
